/* istanbul ignore file */
export * from './InformationBox';
